<div *ngIf="!book">
  <app-loading-spinner></app-loading-spinner>
</div>

<div *ngIf="book">
  <app-navbar></app-navbar>

  <button (click)="back()" class=" btn btn-block mt-1 p-2 btn-danger">
    Back
  </button>
  <div class="jumbotron text-center">
    <h4 class="card-title h4 pb-2">
      <strong>{{ book.title }}</strong>
    </h4>
    <div class="view overlay my-4 waves-light text-center " mdbWavesEffect>
      <img [src]="book.image" width="300" style="margin:0 auto;" />
      <a>
        <div class="mask rgba-white-slight"></div>
      </a>
    </div>
    <p class="card-text">{{ book.description }}</p>
  </div>
  <app-footer></app-footer>
</div>
